<template>
	<inertia-head title="Bo Sanchez FREE Ebook - Seven Success Principles" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Thank you
					</h1>
					
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				
				<div class="block block-rounded">
					<div class="block-content block-content-full text-center">
						<h2>Successfully Process</h2>
						<h3>We send you an email for updates and exclusive rate when tickets go live!</h3>
						<div class="mt-4">
							<inertia-link href="/events" class="btn btn-info">Go Back</inertia-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
			event 			: Object,
		},
		setup(props){

			
			return {
			
			}

		}
	}
</script>